import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-labelledby="guarantee-title" className="w-full bg-white px-4 py-8 sm:px-6" data-id="element-101" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-3xl rounded-2xl border-2 border-brand/40 bg-ivory p-4 text-center sm:p-6" data-id="element-102" data-mp="22367rr28pzr7">
        <span className="inline-flex items-center gap-2 rounded-full bg-brand/15 px-3 py-1 font-head text-[10px] font-semibold uppercase tracking-wider text-brand-dark sm:text-xs" data-id="element-103" data-mp="1x3tk543joonk">
          <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-104" data-mp="14fxswewqvoy6" />
          Zero Risk
        </span>
        <h2 id="guarantee-title" className="mt-1 font-display text-3xl uppercase leading-none text-charcoal sm:text-4xl" data-id="element-105" data-mp="1j4ah2pplc3i4">
          7-Day Money-Back Guarantee
        </h2>
        <p className="mt-2 font-head text-[13px] font-semibold text-charcoal sm:text-base" data-id="element-106" data-mp="qnzrkq99yxck">
          Open the complete system. Review the modules. Explore the sessions, drills, progressions,
          tools, and bonuses.
        </p>
        <p className="mt-1.5 text-[13px] leading-snug text-softgray" data-id="element-107" data-mp="oyqdc7f0ntim">
          Try PADEL COACH PRO™ for seven full days. If you are not completely satisfied, contact us
          within the guarantee period and request a full refund.
        </p>
        <p className="mt-2 font-head text-[11px] font-semibold uppercase tracking-widest text-brand" data-id="element-108" data-mp="yrp51y5t806g">
          Your Purchase Is Protected
        </p>
      </div>
    </section>;
}